// Libraries
var React = require('react');

// Components
var CallToAction = require('../../common/CallToAction/CallToAction');

class CallToActionModule extends React.Component {

	render() {
		return (
			<div className="cta" id={this.props.data.id}>
				<CallToAction button={true} {...this.props.data.link} />
			</div>
		)
	}
}

module.exports = CallToActionModule;



// WEBPACK FOOTER //
// ./src/components/CallToAction/CallToActionModule.js